<template>
  <div>
    <v-app-bar app color="white" class="elevation-pl-3">
      <v-container class="d-flex align-center">
        <router-link :to="{name: 'Home'}" class="d-flex align-center logo-link">
          <v-img
            alt="LCinternet Logo"
            class="shrink mr-2"
            contain
            src="@/assets/logo-lc-internet.svg"
            transition="scale-transition"
            :width="$vuetify.breakpoint.smAndDown ? 120 : 170"
          />
        </router-link>

        <v-spacer></v-spacer>

        <router-link
          :to="{name:'Home'}"
          class="d-flex align-center mr-3"
          v-if="$route.name !== 'Home' && $route.name !== 'Login'"
        >
          <icon-menu class="icon--menu"></icon-menu>
        </router-link>

      </v-container>
    </v-app-bar>
  </div>
</template>

<script>
export default {
  name: "NavBar",
  components: {
    IconMenu: () => import("./icons/IconMenu"),
  },
};
</script>

<style lang="scss" scoped>
.logo-link {
  text-decoration: none;
  cursor: pointer;
}

.icon--menu {
  max-width: 1.8rem;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.icon--menu:hover {
  transform: scale(1.2);
  cursor: pointer;
}

</style>
